import {
  ActionStatus,
  TABLE_DELETE,
  TOKEN_KEY,
} from '@common/constants/shared';
import { setError } from '@common/redux/slice/app';
import { setCurrentRecordIds } from '@common/redux/slice/database';
import { resetValue } from '@common/redux/slice/formInputs';
import store from '@common/redux/store';
import { fetchScreenAction } from '@common/services';
import { ActionTypes, IAction, IObj } from '@common/types';
import { MetadataAction } from '@common/types/action';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { find, get, isEmpty, omit, some } from 'lodash';
import * as actions from './ActionItem';
import qs from 'query-string';
import history from '@common/routes/history';
import { getInputFromField } from './func/helps';
import { Platform } from 'react-native';

export type ActionResponse = {
  status: string;
  message?: string;
  accessToken?: string;
  currentRecordIds?: IObj;
};

const notApiActions = ['navigate', 'logout', 'forgotPassword'];

const isOAuthAction = (actionType: ActionTypes) => {
  return [
    ActionTypes.LINE_LOGIN,
    ActionTypes.DOCOMO_LOGIN,
    ActionTypes.DID_LOGIN,
    ActionTypes.TRUSTDOCK_LOGIN,
    ActionTypes.APPLE_LOGIN,
    ActionTypes.SIGNUP,
    ActionTypes.SIGNIN,
  ].includes(actionType);
};

const allowAPI = (actions: IAction[]) =>
  some(actions, (action) => {
    const conditionals = action.options?.conditionals || [];
    return (
      conditionals.length > 0 || !notApiActions.includes(action.actionType)
    );
  });

function removeParam(key: string[], sourceURL: string) {
  var rtn = sourceURL.split('?')[0],
    param,
    params_arr = [],
    queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    params_arr = queryString.split('&');
    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0];
      if (key.includes(param)) {
        params_arr.splice(i, 1);
      }
    }
    if (params_arr.length) rtn = rtn + '?' + params_arr.join('&');
  }
  return rtn;
}

export const actionPromise = async ({
  objectId,
  actionId,
  clientValues,
  screenUuid,
  currentRecordIds,
  messages,
  data,
  screenAction,
  arrayAction,
  formId,
}: {
  objectId?: string;
  actionId: string;
  clientValues: IObj;
  screenUuid: string;
  currentRecordIds?: IObj;
  messages: IObj;
  data?: IObj;
  screenAction?: boolean;
  arrayAction: any[];
  formId?: string;
}) => {
  try {
    const search = history.location.search;
    const query = qs.parse(search);

    const allowApi = allowAPI(arrayAction);
    let response;

    if (allowApi || actionId === TABLE_DELETE) {
      response = await fetchScreenAction({
        objectId,
        actionId,
        clientValues,
        screenUuid,
        data,
        screenAction,
      });
    } else {
      response = arrayAction;
    }

    const dispatch = store.dispatch;
    const result: any[] = [];
    for (let i = 0; i < response.length; i++) {
      const currentAction = response[i];
      const isActionAvailable = JSON.stringify(
        get(currentAction, 'visibility', true)
      );

      if (isActionAvailable === 'false') continue;

      const isAuthAction = isOAuthAction(currentAction.actionType);

      let res: ActionResponse = await runAction(currentAction, {
        currentRecordIds,
        messages,
        record: data,
        ...(arrayAction &&
          arrayAction.length > 0 && { actionItem: arrayAction[i] }),
      });

      // if (currentAction?.actionType === ActionTypes.LINE_LOGIN) {
      //   if (Platform.OS === 'web') {
      //     var originalURL = window.parent.location.href;
      //     var alteredURL = removeParam(['code', 'type'], originalURL);
      //     window.parent.location.replace(alteredURL);
      //   }

      //   history.push({
      //     search: qs.stringify(omit(query, ['code'])),
      //   });
      // }

      if (res.status === ActionStatus.SUCCESS) {
        const { accessToken = null, currentRecordIds = null } = res;
        if (isAuthAction && accessToken) {
          AsyncStorage.setItem(TOKEN_KEY, accessToken);
        }

        if (currentRecordIds) {
          dispatch(setCurrentRecordIds(currentRecordIds));
        }

        const metadataAction = find(arrayAction, { id: currentAction.id });

        const inputs: Record<string, any> =
          getInputFromField(metadataAction, { record: data, formId }) || {};

        if (
          !isEmpty(inputs) &&
          currentAction.status === ActionStatus.SUCCESS &&
          currentAction?.actionType === 'createObject'
        ) {
          dispatch(resetValue(inputs));
        }
      } else {
        if (isAuthAction) {
          dispatch(setError(res));

          return res;
        }
      }

      result.push({ ...res, actionId: currentAction.id });
    }

    return result;
  } catch (error) {
    console.log('actionPromise', error);
  }
};

export const onPressAction = async (response: any[]) => {
  try {
    const dispatch = store.dispatch;
    const result: any[] = [];
    for (let i = 0; i < response.length; i++) {
      const currentAction = response[i];
      const isActionAvailable = JSON.stringify(
        get(currentAction, 'visibility', true)
      );

      if (isActionAvailable === 'false') continue;

      const isAuthAction = isOAuthAction(currentAction.actionType);

      let res: ActionResponse = await runAction(currentAction, {
        currentRecordIds: {},
        messages: {},
      });

      if (res.status === ActionStatus.SUCCESS) {
        if (isAuthAction && res.accessToken) {
          localStorage.setItem(TOKEN_KEY, res.accessToken);
        }

        if (res?.currentRecordIds) {
          dispatch(setCurrentRecordIds(res?.currentRecordIds));
        }
      } else if (isAuthAction) {
        dispatch(setError(res));
        return res;
      }

      result.push(res);
    }

    return result;
  } catch (error) {
    console.log('actionPromise', error);
  }
};

function runAction(action: IAction, metadata: MetadataAction) {
  const { actionType } = action;

  switch (actionType) {
    // signin user action___________
    case ActionTypes.SIGNIN:
    case ActionTypes.LINE_LOGIN:
      return actions.signIn(action, metadata);

    // //signup user action___________
    case ActionTypes.SIGNUP:
      return actions.signUp(action, metadata);

    // //Logout user
    case ActionTypes.LOGOUT:
      return actions.logOut(action);

    //forgot password
    case ActionTypes.FORGOT_PASSWORD:
      return actions.forgotPassword(action, metadata);

    //create user
    case ActionTypes.CREATE_OBJECT:
      return actions.createObject(action, metadata);

    //update user
    case ActionTypes.UPDATE_OBJECT:
      return actions.updateObject(action, metadata);

    // //delete user
    case ActionTypes.DELETE_OBJECT:
      return actions.deleteObject(action, metadata);

    //set Input value
    case ActionTypes.SET_INPUT_VALUE:
      return actions.setInputValue(action, metadata);

    // send email
    case ActionTypes.SEND_EMAIL:
      return actions.sendEmail(action, metadata);

    //push notification
    case ActionTypes.PUSH_NOTIFICATION:
      return actions.pushNotification(action, metadata);

    //external link
    case ActionTypes.EXTERNAL_LINK:
      return actions.externalLink(action, metadata);

    // //customAction
    case ActionTypes.CUSTOM:
      return actions.customAction(action, metadata);

    case ActionTypes.TRACKING_ANALYSTIC:
      return actions.sendEventAnalytics(action);

    // navigate action________________
    default:
      return actions.executeNavigate(action, metadata);
  }
}
